import { tss } from 'tss-react/mui';

import { SourceDialogMode } from '../SourceCreate.types';

const useStyles = tss
  .withParams<{ mode: string }>()
  .create(({ theme, mode }) => ({
    dialogContainer: {
      backgroundColor: theme.vars.palette.transparent.a25,
      '& .MuiDialog-container': {
        '& .MuiPaper-root': {
          width: '100%',
          maxWidth: mode === SourceDialogMode.Delete ? '35rem' : '70rem'
        }
      }
    },
    sourceCreateDialogStepper: {
      backgroundColor: theme.vars.palette.background.default
    },
    footerMessage: {
      color: theme.vars.palette.warning.main,
      position: 'absolute',
      left: '1.25rem',
      display: 'flex',
      alignItems: 'center'
    },
    sourceCreateDialogIconButtonCancel: {
      height: '2rem',
      position: 'absolute',
      right: 8,
      top: 8,
      width: '2rem'
    }
  }));

export default useStyles;
